import { Component, Input, Output, EventEmitter, OnChanges, SimpleChanges, AfterViewInit } from '@angular/core';
import { FormGroup, FormControl, Validator, Validators} from '@angular/forms';
import colorsJsonGreen from './../../../../assets/teiasoft-themes/green.json';
import colorsJsonBlue from './../../../../assets/teiasoft-themes/blue.json';
import colorsJsonSilver from './../../../../assets/teiasoft-themes/silver.json';

@Component({
  selector: 'teiasoft-login',
  templateUrl: './teiasoft-login.component.html',
  styleUrls: ['./teiasoft-login.component.scss']
})
export class TeiasoftLoginComponent implements AfterViewInit {
  @Input() loginTitle: string = "";
  @Input() courtesyTitle:string = "Please, log in";
  @Input() showIcon:boolean = false;
  @Input() showBorder: boolean = true;
  @Input() showPasswordRecovery: boolean = true;
  @Input() theme:string = "blue";
  @Input() pathLogo:string = "";
  @Input() isMobile:boolean = false;
  @Input() appVersion: string = "";
  
  @Output() onLoginClick: EventEmitter<any> = new EventEmitter();
  @Output() onRecoveryPwdClick: EventEmitter<any> = new EventEmitter();
  @Output() onKeyEnter: EventEmitter<any> = new EventEmitter();

  loginForm: FormGroup = new FormGroup({
    user: new FormControl('',[Validators.required]), //, Validators.email
    pwd: new FormControl('',[Validators.required])
  });

  mobileW:number = 0;
  constructor(){
    //this.setFormValidation();
  }


  ngAfterViewInit(): void {
    this.mobileW = window.innerWidth*0.95;
  }

 

  onInputSetUsername(evt:any){
    this.loginForm.controls["user"].setValue(evt);
  }

  onInputSetPwd(evt:any){
    this.loginForm.controls["pwd"].setValue(evt);
  }

  loginClick(){
    let _obj: any = {userName: this.loginForm.controls["user"].value, password: this.loginForm.controls["pwd"].value}
    this.onLoginClick.emit(_obj)
  }

  linkClick(){
    this.onRecoveryPwdClick.emit('');
  }

  onKeyUp(evt:KeyboardEvent){
    if (this.loginForm.controls["user"].value != '' &&  this.loginForm.controls["pwd"].value != '' && evt.code == "Enter"){
      let _obj: any = {userName: this.loginForm.controls["user"].value, password: this.loginForm.controls["pwd"].value}
      this.onKeyEnter.emit(_obj);
    }
  }

/*   emailValidator(control: FormControl) {
    const isValid = control.value && control.value.match('^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$');
    return isValid ? null : true; // { 'pwd': true };
  } */
}
